module.exports = __webpack_public_path__ + "img/twitter.2f5f096d.png";